import { azureBlobStorageLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

azureBlobStorageLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { AzureBlobStorageLinkedService } from 'shell-models-lib';

